import React from 'react'
import '../../styles/css/Card.css';
import { decryptBase64, isNullUndefinedOrEmpty } from '../../common/Helpers.js';
import { PARAM_NAME_PW } from '../../configurations/strings.config.js';
import { authHeaderJson } from '../../services/auth-header.service.js';
import { WEB_AUTH_URL, WEB_CORE_URL } from '../../configurations/paths.config.js';
import axios from 'axios';
import { checkAuth, removeAuth } from '../../services/Auth/auth.service.js';

async function Login() {  
    const checkResponse = await checkAuth();

    if (!isNullUndefinedOrEmpty(checkResponse) && checkResponse.data.code === "SESSION_COOKIES_ERROR") {
        removeAuth();
        window.location.href = `${WEB_AUTH_URL}`
    }
    else if (!isNullUndefinedOrEmpty(checkResponse) && checkResponse.data.code === "SESSION_COOKIES_OK") {
        window.location.href = `${WEB_CORE_URL}`
    }

    return (
        <>

        </>
    );
}

export default Login;